import React from "react";
import { Typography, useTheme, Box } from "@mui/material";
import { useStreamContext } from "~contexts/Stream";
import BrandSelector from "~components/atoms/BrandSelector";

const Home: React.FC = () => {
  const theme: any = useTheme();
  const { currentStream } = useStreamContext();

  // Se não há brand selecionada, mostrar mensagem
  if (!currentStream) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          minHeight: "60vh",
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            color: theme.palette.grey[0],
            fontSize: "30px !important",
          }}
          variant="h1"
        >
          bem-vindo ao ambiente AzzasLive
        </Typography>
        <Typography
          sx={{
            color: theme.palette.grey[600],
            fontSize: "15px",
            marginBottom: "24px",
          }}
        >
          comece a configurar sua live pelo menu ao lado após selecionar uma marca
        </Typography>
        <BrandSelector invertColors={true} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        minHeight: "60vh",
        textAlign: "center",
      }}
    >
      <Typography
        sx={{
          color: theme.palette.grey[0],
          fontSize: "30px !important",
        }}
        variant="h1"
      >
        bem-vindo ao ambiente AzzasLive
      </Typography>
      <Typography
        sx={{
          color: theme.palette.grey[600],
          fontSize: "15px",
          marginBottom: "24px",
        }}
      >
        comece a configurar sua live pelo menu ao lado após selecionar uma marca
      </Typography>
    </Box>
  );
};

export default Home;
